/**
 * 模块 - 运营中心 - 中文
 */
export default {
  // 直接作为根级属性，方便使用 $t('operationCenter.xxx')
  operationCenter: {
    expressCompany: '快递公司',
    prepaidFreight: '预付运费',
    auto_43: '支付',
    auto_44: '修改',
    auto_45: '详情',
    auto_46: '发货',
    auto_47: '收货确认',
    auto_48: '收货确认',
    auto_113: '收货确认',
    auto_49: '取消',
    auto_50: '取消',
    auto_114: '取消',
    auto_51: '审核',
    auto_52: '发货',
    auto_53: '收货确认',
    auto_54: '支付',
    auto_55: '修改',
    auto_56: '详情',
    auto_57: '取消',
    auto_58: '详情',
    auto_59: '取消',
    auto_60: '修改',
    auto_61: '详情',
    auto_62: '取消',
    auto_63: '发货',
    auto_64: '详情',
    auto_65: '取消',
    auto_66: '详情',
    auto_67: '详情',
    auto_68: '详情',
    auto_69: '详情',
    auto_70: '收货确认',
    auto_71: '详情',
    auto_72: '详情',
    auto_73: '审核',
    auto_74: '详情',
    auto_75: '详情',
    auto_76: '详情',
    auto_77: '收货确认',
    auto_78: '详情',
    auto_79: '发货',
    auto_80: '详情',
    auto_81: '详情',
    auto_82: '详情',
    auto_83: '详情',
    auto_84: '换入商品发货中',
    auto_85: '详情',
    auto_86: '待支付',
    auto_87: '支付',
    auto_88: '修改',
    auto_89: '取消',
    auto_90: '待审核',
    auto_91: '取消',
    auto_92: '审核',
    auto_93: '已退回',
    auto_94: '修改',
    auto_95: '取消',
    auto_96: '发货中',
    auto_97: '待发货',
    auto_98: '发货',
    auto_99: '已发货',
    auto_100: '收货确认',
    auto_101: '待发货',
    auto_102: '发货',
    auto_103: '已发货',
    auto_104: '收货确认',
    auto_105: '已完成',
    auto_106: '已取消',
    auto_33: '发送验证码',
    auto_34: '重新发送',
    auto_35: '发送验证码',
    auto_36: '重新发送',
    auto_37: '学习机一旦标记为样机',
    auto_38: '提示',
    auto_39: '确定',
    auto_40: '取消',

    auto_41: '采购单号调货单号',
    auto_42: '收货人',
    auto_32: '待选区',
    auto_21: '请输入码或采购单号',
    auto_22: '待选',
    auto_23: '已选',
    auto_24: '已激活',
    auto_25: '未激活',
    auto_26: '已激活',
    auto_27: '未激活',

    auto_16: '采购单号',
    auto_17: '代理商名称',
    auto_18: '创建人',
    auto_19: '发货仓库',
    auto_20: '请选择发货仓库',
    auto_28: '收货地址',
    auto_29: '请输入校区地址',
    auto_30: '备注',
    auto_31: '请输入备注200字以内',
    auto_11: '商品名称',
    auto_12: '数量',
    auto_13: '订单编号',
    auto_14: '订单商品',
    auto_15: '订单待发货数量',

    auto_1: '采购单号',
    auto_2: '代理商名称',
    auto_3: '创建人',
    auto_4: '发货仓库',
    auto_5: '请选择发货仓库',
    auto_6: '收货人',
    auto_7: '收货人电话',
    auto_8: '省市区',
    auto_9: '发货状态',
    auto_10: '发货状态',

    auto_107: '数量',
    auto_108: '商品',
    auto_109: '王小虎',
    auto_110: '啊是否把卡上吧狂放不',
    auto_111: '王小虎',
    auto_112: '啊是否把卡上吧狂放不',
    auto_115: '换出商品',
    auto_116: '换入商品',
    auto_117: '单价',

    auto_137: '换入',
    auto_138: '换入',
    auto_139: '换入',
    auto_140: '换入',
    auto_141: '换入',
    auto_142: '换入',
    auto_143: '换入',
    auto_144: '换入',
    auto_145: '换入',
    auto_146: '换出',

    auto_120: '总部发货',
    auto_121: '门店收货',
    auto_122: '主仓',
    auto_123: '门店收货',

    auto_126: '请输入码',
    auto_127: '发货',
    auto_128: '换出商品发货',
    auto_129: '换入商品发货',
    auto_130: '单价',

    auto_124: '返回',
    auto_118: '暂无数据',
    auto_119: '门店收货',

    auto_134: '区代发货记录导出',
    auto_135: '取消失败',

    auto_136: '销售发货导出',

    auto_132: '保费',
    auto_133: '保费',

    auto_125: '修改失败',

    auto_131: '京东仓发货参数配置导',

    // 区域京东发货 — saleConsignmentDetailNew（避免 auto_21～auto_27 与调货穿梭框文案混用）
    textkwso: '商品详情',
    texti5zt: '关联订单',
    textjenf: '物流详情',
    saleConsignmentDetailSendStatusPh: '发货状态',
    saleConsignmentDetailJdOutboundNo: '京东仓出库编号',
    saleConsignmentDetailAgentRecvWarehouse: '代理商收货仓',
    saleConsignmentDetailRemarkPh: '请输入备注，200字以内',
    saleConsignmentTraceShippingDate: '发货日期',
    saleConsignmentTraceExpressCompany: '快递公司',
    saleConsignmentTraceWayBill: '快递单号',
    saleConsignmentTraceLogisticsStatus: '物流状态',
    saleConsignmentTraceShipNum: '发货数量',

    // 总部发货-调货弹窗（HeadOfficeModal），专用 key，避免与 auto_* 混用冲突
    headOfficeTransferModalTitle: '调货',
    headOfficeTransferModalAgentIdLabel: '代理商ID:',
    headOfficeTransferModalProductNameLabel: '商品名称:',
    headOfficeTransferModalPONoLabel: '采购单号/调货单号:',
    headOfficeTransferModalReceiverLabel: '收货人:',
    headOfficeTransferModalReceiverPhoneLabel: '收货人电话:',
    headOfficeTransferModalProvinceCityLabel: '所在省市:',
    headOfficeTransferModalAddressLabel: '收货地址:',
    headOfficeTransferModalOrderQtyLabel: '订购数量:',
    headOfficeTransferModalShippedQtyLabel: '已发数量:',
    headOfficeTransferModalExpressCompanyLabel: '快递公司:',
    headOfficeTransferModalSelectExpressPlaceholder: '请选择快递公司',
    headOfficeTransferModalExpressNoLabel: '快递单号:',
    headOfficeTransferModalFillExpressNo: '请填写快递单号',
    headOfficeTransferModalPendingZone: '待选区',
    headOfficeTransferModalSelectedZone: '已选区',
    headOfficeTransferModalActivated: '已激活',
    headOfficeTransferModalNotActivated: '未激活',
    headOfficeTransferModalFilterSnPurchasePlaceholder: '请输入SN码或采购单号',
    headOfficeTransferModalTransferPending: '待选',
    headOfficeTransferModalTransferSelected: '已选',
  }
};

